import { render, staticRenderFns } from "./ContentGroup.vue?vue&type=template&id=79ce82ce"
import script from "../../services/upload/content-group.js?vue&type=script&lang=js&external"
export * from "../../services/upload/content-group.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/content-group.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports